import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  root: {
    border: '1px solid rgb(224, 224, 224)',
    borderRadius: 8,
    marginBottom: 16,
    overflow: 'auto'
  },

  table: {
    height: 'calc(100vh - 342px)',
    minHeight: 350,
    width: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
      width: 0,
      height: 0
    }
  },

  thead: {
    fontWeight: '500',
    background: theme.palette.primary.main,
    color: 'white',
    borderBottom: '1px solid rgb(224, 224, 224)',
    display: 'grid',

    '& > div': {
      border: 'none'
    },
    '& > div > div:first-child': {
      maxWidth: 100,
      minWidth: 70,
    }
  },

  trowhead: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    height: 50,
    background: theme.palette.primary.main,

    [theme.breakpoints.down('1070')]: {
      height: 40,
    },

    '::-webkit-scrollbar': {
      display: 'none',
      width: 0,
      height: 0
    }
  },

  tbody: {
    height: 'calc(100% - 50px)',
    '& > div > div:first-child': {
      height: '100%',
      maxWidth: 100,
      minWidth: 70,
      borderRight: '1px solid rgb(224, 224, 224)',
      display: 'grid',
      placeItems: 'center'
    }
  },
  
  trow: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid rgb(224, 224, 224)',
    height: 50,
    [theme.breakpoints.down('1070')]: {
      height: 40,
    }
  },

  titem: {
    width: '100%',
    minWidth: 30
  },

  titemhead: {
    width: '100%',
    minWidth: '38px'
  },

  creneau: {
    cursor: 'pointer',
    borderRadius: 4,
    display: 'grid',
    placeItems: 'center',
    height: 40,
    color: 'white',
    
    transition: 'all ease-in-out .1s',

    '& > p': {
      margin: 0,
      overflow: 'hidden', 
      textOverflow: 'ellipsis', 
      whiteSpace: 'nowrap', 
      maxWidth: '90%',
    },
    '& > svg': {
      display: 'none'
    },

    '&:hover': {
      marginLeft: -4,
      marginRight: -4,
      marginTop: -4,
      marginBottom: -4,
      height: 50,
      fontSize: 18
    },

    [theme.breakpoints.down('1070')]: {
      height: 30,
      '&:hover': {
        height: 40,
      },
      '& > p': {
        display: 'none'
      },
      '& > svg': {
        display: 'block'
      },
    }
  },

  valid: {
    backgroundColor: '#2ecc71'
  },
  waiting:{
    backgroundColor: '#95a5a6'
  },
  invalid: {
    cursor: 'not-allowed',
    backgroundColor: '#e74c3c',
    '&:hover': {
      margin: 0,
      height: 40,
      borderRadius: 4,
      fontSize: 16,
      [theme.breakpoints.down('1070')]: {
        height: 30,
      }
    }
  },
  reserved: {
    backgroundColor: '#fa983a',
    '& > p': {
      display: 'block!important'
    },
  },

  libelleTerrain: {
    [theme.breakpoints.down('1070')]: {
      display: 'none'
    }
  },
  typeTerrain: {
    [theme.breakpoints.down('1070')]: {
      display: 'none'
    }
  }

}))
